export default function BootScreen({ label = "" }: { label?: string }) {
  return (
    <div data-testid="boot" className="foyer-boot">
      <div className="foyer-boot__logo">Foyer</div>
      {label && <div className="foyer-boot__label">{label}</div>}
    </div>
  );
}
